// extracted by mini-css-extract-plugin
module.exports = {"container":"b429494557--container--PJEmj","value":"b429494557--value--FO4sx","icon":"b429494557--icon--bXL3_"};